export default __webpack_public_path__ + "static/used_cars_masters-305836de37febacbbbadc7e86f503956.png";